import { memo } from 'react';

import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import Check from '@material-ui/icons/Check';
import Close from '@material-ui/icons/Close';
import clsx from 'clsx';

import { useStyles } from './ConfirmationAdornment.styles';
import { ConfirmationAdornmentProps } from './ConfirmationAdornment.types';

export const ConfirmationAdornment = memo(({ onConfirm, onReject }: ConfirmationAdornmentProps) => {
  const styles = useStyles();

  return (
    <InputAdornment position="end">
      <div className={styles.wrapper}>
        <IconButton onClick={onConfirm} className={styles.button}>
          <Check />
        </IconButton>

        <IconButton onClick={onReject} className={clsx(styles.button, styles.warningBtn)}>
          <Close />
        </IconButton>
      </div>
    </InputAdornment>
  );
});
